var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgLogoDayMobile = function SvgLogoDayMobile(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 97,
    height: 34,
    viewBox: "158 17 97 34",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 34,
    viewBox: "0.335 0 48.33 34",
    fill: "#e30185",
    x: 206,
    y: 17,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 34,
    viewBox: "0.961 0 47.686 33.547",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    paintOrder: "stroke fill markers",
    fillRule: "evenodd",
    d: "M48.647 26.93V19.88a30.893 30.893 0 0 1-.07-3.746c.02-.506.045-1.012.07-1.518V9.089c-.051-.261-.151-.506-.365-.675-.437-.347-1.122-.415-1.653-.486-.665-.088-1.33-.162-1.993-.26a185.946 185.946 0 0 1-4.512-.708c-1.523-.262-3.029-.602-4.547-.889-1.33-.25-2.66-.524-4.003-.688-.958-.116-1.999-.228-2.868-.693L12.47 1.818a46.114 46.114 0 0 1-1.366-.197c-1.043-.164-2.08-.353-3.125-.514-.871-.135-1.758-.19-2.618-.39C4.608.543 3.866.318 3.109.162L2.453.046C1.963-.021 1.462-.032.999.13.986.135.974.137.961.139v2.662l.045.322c.082.61.102 1.2.085 1.815-.022.77-.071 1.537-.13 2.303v9.035c.034.312.064.625.079.94.032.697-.017 1.397-.079 2.093V29.85c.102.477.163.957.171 1.45.007.427-.02.855.015 1.28.023.29.09.58.314.763.115.093.252.157.397.203l5.679-.766c1.211-.386 2.423-.791 3.683-.978 1.595-.237 3.205-.237 4.812-.282a44.37 44.37 0 0 0 1.21-.048l4.037-.545c1.482-.265 2.963-.553 4.452-.79.906-.144 1.819-.164 2.734-.179l20.08-2.708c.036-.107.071-.214.102-.322z"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    width: 2,
    height: 1,
    viewBox: "0.731 0 0.538 1",
    fill: "#fff",
    x: 219,
    y: 23,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("svg", _extends({
    width: 2,
    height: 1,
    viewBox: "0.971 0.241 0.036 0.067",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    paintOrder: "stroke fill markers",
    fillRule: "evenodd",
    d: "M.971.24L.99.308l.017-.06A.576.576 0 0 1 .971.242z"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    width: 1,
    height: 1,
    viewBox: "0.192 0 0.615 1",
    fill: "#fff",
    x: 219,
    y: 26,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("svg", _extends({
    width: 1,
    height: 1,
    viewBox: "0.462 0.465 0.035 0.057",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    paintOrder: "stroke fill markers",
    fillRule: "evenodd",
    d: "M.497.473L.462.465C.468.488.47.5.477.523l.02-.05z"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    width: 1,
    height: 1,
    viewBox: "0.255 0 0.49 1",
    fill: "#fff",
    x: 239,
    y: 31,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("svg", _extends({
    width: 1,
    height: 1,
    viewBox: "0.947 0.124 0.04 0.082",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    paintOrder: "stroke fill markers",
    fillRule: "evenodd",
    d: "M.987.161L.965.124C.958.136.944.15.947.16.952.177.969.19.98.205A.83.83 0 0 0 .987.161z"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    width: 1,
    height: 1,
    viewBox: "0.102 0 0.795 1",
    fill: "#fff",
    x: 238,
    y: 27,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("svg", _extends({
    width: 1,
    height: 1,
    viewBox: "0.222 0.923 0.048 0.06",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    paintOrder: "stroke fill markers",
    fillRule: "evenodd",
    d: "M.27.97L.258.923C.246.928.228.928.223.938c-.004.01.006.03.01.045L.27.97z"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    width: 1,
    height: 1,
    viewBox: "0.174 0 0.652 1",
    fill: "#fff",
    x: 241,
    y: 29,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("svg", _extends({
    width: 1,
    height: 1,
    viewBox: "0.056 0.265 0.028 0.044",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    paintOrder: "stroke fill markers",
    fillRule: "evenodd",
    d: "M.084.29L.057.265.056.31.084.29z"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    width: 1,
    height: 1,
    viewBox: "0.21 0 0.581 1",
    fill: "#fff",
    x: 226,
    y: 28,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("svg", _extends({
    width: 1,
    height: 1,
    viewBox: "0.768 0.134 0.03 0.051",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    paintOrder: "stroke fill markers",
    fillRule: "evenodd",
    d: "M.786.134l-.018.04.03.01-.012-.05z"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    width: 2,
    height: 1,
    viewBox: "0.731 0 0.538 1",
    fill: "#fff",
    x: 219,
    y: 23,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("svg", _extends({
    width: 2,
    height: 1,
    viewBox: "0.971 0.241 0.036 0.067",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    paintOrder: "stroke fill markers",
    fillRule: "evenodd",
    d: "M.971.24a.576.576 0 0 0 .036.008L.99.308A3.26 3.26 0 0 0 .97.24z"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    width: 1,
    height: 1,
    viewBox: "0.192 0 0.615 1",
    fill: "#fff",
    x: 219,
    y: 26,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("svg", _extends({
    width: 1,
    height: 1,
    viewBox: "0.462 0.465 0.035 0.057",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    paintOrder: "stroke fill markers",
    fillRule: "evenodd",
    d: "M.497.473l-.02.05C.47.5.468.488.462.465l.035.008z"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 29,
    viewBox: "0.017 0 12.966 29",
    fill: "#fff",
    x: 209,
    y: 19,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 29,
    viewBox: "0.517 0.908 12.361 27.647",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    paintOrder: "stroke fill markers",
    fillRule: "evenodd",
    d: "M12.804 21.267c-.022-.105 0-.232.008-.347.05-.702.104-1.38-.103-2.03-.037-.12-.03-.265-.038-.397-.012-.2-.008-.401-.03-.597-.092-.81-.024-1.605-.061-2.392-.003-.063.012-.127.017-.19.05-.61-.067-1.23.029-1.83.003-.019-.008-.042-.008-.063-.019-.445-.036-.891-.054-1.34-.006-.149-.004-.299-.016-.448-.03-.364-.08-.729-.099-1.096a18.638 18.638 0 0 0-.217-2.184c-.068-.397-.076-.806-.082-1.224-.013-.922-.088-1.881-.14-2.88a.945.945 0 0 0-.035-.223c-.018-.06-.037-.132-.062-.187a.436.436 0 0 0-.094-.354v-.149c0-.144.026-.315-.049-.445-.084-.148-.25-.178-.4-.22a21.432 21.432 0 0 0-1.312-.323 22.665 22.665 0 0 0-.457-.095c-.144-.028-.32-.088-.465-.075-.092.008-.197.045-.24.137-.085.186-.096.414-.133.615a.35.35 0 0 0 .005.131c-.186.358-.226.757-.293 1.152l-.241 1.413a349.919 349.919 0 0 1-1.167 6.365c-.036-.104-.07-.209-.11-.311-.346-1.393-.722-2.778-1.099-4.163l-.835-3.078a.251.251 0 0 0 .004-.16 65.08 65.08 0 0 1-.718-2.612.274.274 0 0 0-.193-.193 34.668 34.668 0 0 0-2.98-.537C.966.913.779.863.639.996c-.217.205-.1.613.016.888v.001a.36.36 0 0 0-.035.074.12.12 0 0 0 .01.102c0 .004-.003.007-.003.01l.027 10.126c.008 3.36.007 6.718.027 10.076.01 1.491.044 2.983.144 4.47a.686.686 0 0 0-.058.262c.014.217.01.434-.013.65a.518.518 0 0 0 .06.267c.001.006.005.01.007.016l.001.027c.006.089.017.177.029.264.012.088.025.176.09.242.114.116.282.096.42.035.058-.025.109-.063.164-.094l.026-.014c.02.005.035.012.055.014.271.017.573-.05.841-.085.56-.072 1.116-.168 1.667-.29.25-.057.395-.147.394-.422 0-.084-.005-.167-.007-.251.021.005.042.01.063.021.003-.059.007-.118.014-.177-.024-.04-.055-.077-.085-.116l-.021-.51a.13.13 0 0 0-.068-.112c.097-.985.127-3.502.122-4.074-.003-.308-.036-.612-.038-.914-.007-.73-.169-1.45.011-2.147.016-.063.004-.147-.006-.218-.11-.767.022-1.541-.144-2.287-.034-.15 0-.327.007-.49.007-.142.027-.28.027-.42.002-.866-.002-1.723.001-2.578 0-.083-.004-.194.115-.198.1.363.227.728.294 1.106.059.335.263.569.324.862.069.325.032.685.13 1.025.144.505.277 1.018.403 1.537.224.923.445 1.859.655 2.822.16.736.234.856.878.732.067-.014.132-.054.196-.088.209-.11.41-.258.625-.323.244-.076.343-.293.376-.6.038-.354.057-.71.095-1.056.045-.415.025-.842.195-1.212.049-.108.039-.267.056-.4.031-.248.056-.496.095-.737.088-.547.187-1.083.272-1.619.089-.559.157-1.12.253-1.67.037-.21.077-.418.118-.625a44.91 44.91 0 0 0-.039 1.747c.002 1.334.205 2.656.265 3.986.119 2.66-.254 5.319-.05 7.978a.426.426 0 0 0-.037.265c-.016.065-.03.13-.036.194-.02.23.144.422.38.42.098 0 .175-.037.265-.066a.883.883 0 0 1 .237-.039c.19-.008.38-.01.57-.026.396-.037.79-.104 1.18-.175.222-.04.411-.13.43-.382.016-.202-.001-.412-.003-.615 0-.019-.007-.034-.011-.051a.396.396 0 0 0 .095-.258l.038-2.29c.004-.06.008-.112.012-.148.085-.75.193-1.462.044-2.17zM6.55 11.344c-.022-.097-.047-.193-.068-.29-.043-.201-.082-.404-.121-.605l.056.213c.06.228.115.456.172.684a.37.37 0 0 0-.04-.002z"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    width: 1,
    height: 3,
    viewBox: "0.259 0 0.481 3",
    fill: "#fff",
    x: 240,
    y: 25,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("svg", _extends({
    width: 1,
    height: 3,
    viewBox: "0.603 0.792 0.224 1.394",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    paintOrder: "stroke fill markers",
    fillRule: "evenodd",
    d: "M.753.792c.115.44.063.832.057 1.22a.248.248 0 0 1-.085.174c-.11-.475-.22-.963.028-1.394z"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    width: 1,
    height: 2,
    viewBox: "0 0.039 1 1.922",
    fill: "#fff",
    x: 234,
    y: 33,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("svg", _extends({
    width: 1,
    height: 2,
    viewBox: "0.577 0.544 0.316 0.608",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    paintOrder: "stroke fill markers",
    fillRule: "evenodd",
    d: "M.893 1.142C.662 1.041.582.85.577.544c.234.174.276.389.31.608l.006-.01z"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    width: 1,
    height: 2,
    viewBox: "0.4 0 0.201 2",
    fill: "#fff",
    x: 240,
    y: 28,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("svg", _extends({
    width: 1,
    height: 2,
    viewBox: "0.839 0.635 0.046 0.457",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    paintOrder: "stroke fill markers",
    fillRule: "evenodd",
    d: "M.839 1.085v-.45l.046.007v.45l-.046-.007z"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    width: 1,
    height: 2,
    viewBox: "0.018 0 0.965 2",
    fill: "#fff",
    x: 238,
    y: 26,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("svg", _extends({
    width: 1,
    height: 2,
    viewBox: "0.291 0.814 0.124 0.258",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    paintOrder: "stroke fill markers",
    fillRule: "evenodd",
    d: "M.415.923C.401.967.39 1.02.366 1.061c-.01.018-.05.008-.075.01C.296 1.005.295.934.308.87.314.843.351.831.375.814l.04.11z"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    width: 1,
    height: 1,
    viewBox: "0.085 0 0.83 1",
    fill: "#fff",
    x: 241,
    y: 30,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("svg", _extends({
    width: 1,
    height: 1,
    viewBox: "0.156 0.426 0.156 0.188",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    paintOrder: "stroke fill markers",
    fillRule: "evenodd",
    d: "M.156.515L.253.426c.02.039.05.077.059.116C.315.565.284.591.269.615a19.975 19.975 0 0 0-.113-.1z"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    width: 1,
    height: 1,
    viewBox: "0.215 0 0.569 1",
    fill: "#fff",
    x: 236,
    y: 32,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("svg", _extends({
    width: 1,
    height: 1,
    viewBox: "0.67 0.281 0.051 0.09",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    paintOrder: "stroke fill markers",
    fillRule: "evenodd",
    d: "M.72.332l-.025.04C.686.357.667.337.67.331.679.312.696.298.71.282c.005.016.008.033.01.05z"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    width: 1,
    height: 1,
    viewBox: "0.129 0 0.743 1",
    fill: "#fff",
    x: 238,
    y: 26,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("svg", _extends({
    width: 1,
    height: 1,
    viewBox: "0.506 0.048 0.087 0.117",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    paintOrder: "stroke fill markers",
    fillRule: "evenodd",
    d: "M.528.048C.549.07.573.088.59.114.596.124.588.165.583.165.558.165.532.155.506.15L.528.048z"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    width: 1,
    height: 1,
    viewBox: "0.255 0 0.49 1",
    fill: "#fff",
    x: 239,
    y: 31,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("svg", _extends({
    width: 1,
    height: 1,
    viewBox: "0.947 0.124 0.04 0.082",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    paintOrder: "stroke fill markers",
    fillRule: "evenodd",
    d: "M.987.161A.83.83 0 0 1 .98.205C.97.191.952.177.947.161.944.15.958.136.965.124L.987.16z"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    width: 1,
    height: 1,
    viewBox: "0.204 0 0.592 1",
    fill: "#fff",
    x: 237,
    y: 32,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("svg", _extends({
    width: 1,
    height: 1,
    viewBox: "0.747 0.164 0.059 0.1",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    paintOrder: "stroke fill markers",
    fillRule: "evenodd",
    d: "M.806.21L.764.264C.758.248.744.229.748.218.756.197.774.181.788.164c.006.015.013.03.018.046z"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    width: 1,
    height: 1,
    viewBox: "0.102 0 0.795 1",
    fill: "#fff",
    x: 238,
    y: 27,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("svg", _extends({
    width: 1,
    height: 1,
    viewBox: "0.222 0.923 0.048 0.06",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    paintOrder: "stroke fill markers",
    fillRule: "evenodd",
    d: "M.27.97L.232.983C.23.967.22.947.223.938.228.928.246.928.258.923L.27.97z"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    width: 1,
    height: 1,
    viewBox: "0.174 0 0.652 1",
    fill: "#fff",
    x: 241,
    y: 29,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("svg", _extends({
    width: 1,
    height: 1,
    viewBox: "0.056 0.265 0.028 0.044",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    paintOrder: "stroke fill markers",
    fillRule: "evenodd",
    d: "M.084.29L.056.31.057.265.084.29z"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    width: 1,
    height: 1,
    viewBox: "0 0.016 1 0.969",
    fill: "#fff",
    x: 236,
    y: 31,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("svg", _extends({
    width: 1,
    height: 1,
    viewBox: "0.38 0.527 0.059 0.057",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    paintOrder: "stroke fill markers",
    fillRule: "evenodd",
    d: "M.407.584L.38.556.432.527c.002.013.01.03.006.04-.004.01-.02.012-.031.017z"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    width: 1,
    height: 1,
    viewBox: "0.4 0 0.2 1",
    fill: "#fff",
    x: 234,
    y: 34,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("svg", _extends({
    width: 1,
    height: 1,
    viewBox: "0.866 0.144 0.037 0.185",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    paintOrder: "stroke fill markers",
    fillRule: "evenodd",
    d: "M.888.152L.903.33.866.325l.026-.18-.004.007z"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    width: 1,
    height: 3,
    viewBox: "0.048 0 0.905 3",
    fill: "#fff",
    x: 244,
    y: 32,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("svg", _extends({
    width: 1,
    height: 3,
    viewBox: "0.282 0.85 0.378 1.254",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    paintOrder: "stroke fill markers",
    fillRule: "evenodd",
    d: "M.395 1.187C.361 1.067.324.945.435.855c.018-.013.062 0 .128.003.003.354.129.703.09 1.055-.015.142-.098.206-.26.184l.005.007c-.034-.197-.064-.395-.107-.592-.03-.136.018-.238.103-.33l-.026.077.027-.072z"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    width: 1,
    height: 2,
    viewBox: "0.284 0 0.432 2",
    fill: "#fff",
    x: 244,
    y: 34,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("svg", _extends({
    width: 1,
    height: 2,
    viewBox: "0.274 0.097 0.244 1.131",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    paintOrder: "stroke fill markers",
    fillRule: "evenodd",
    d: "M.393.097c.17.307.117.624.118.939 0 .052-.057.1-.112.192C.183.809.289.457.4.105L.393.097z"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    width: 1,
    height: 1,
    viewBox: "0.152 0 0.696 1",
    fill: "#fff",
    x: 245,
    y: 29,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("svg", _extends({
    width: 1,
    height: 1,
    viewBox: "0.165 0.01 0.083 0.119",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    paintOrder: "stroke fill markers",
    fillRule: "evenodd",
    d: "M.248.107C.225.114.203.123.18.129.174.098.16.062.167.035.17.02.209.018.232.01l.016.097z"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 24,
    viewBox: "0.222 0 9.555 24",
    fill: "#fff",
    x: 222,
    y: 22,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 24,
    viewBox: "0.492 0.353 9.41 23.635",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    paintOrder: "stroke fill markers",
    fillRule: "evenodd",
    d: "M9.888 22.26l-.002-.01a.745.745 0 0 0-.007-.098c-.01-.068-.198-1.61-.213-1.676-.132-.543-.297-1.055-.293-1.628.001-.205-.103-.41-.163-.61-.066-.22-.174-.428-.2-.652-.144-1.23-.522-2.317-.792-3.431-.144-.598-.286-1.192-.373-1.796-.086-.59-.245-1.156-.387-1.734-.104-.427-.23-.853-.304-1.293-.073-.44-.087-.893-.294-1.313-.043-.087-.038-.205-.062-.308-.07-.307-.14-.618-.216-.932a13.465 13.465 0 0 0-.15-.565c-.315-1.112-.631-2.28-.95-3.526a.797.797 0 0 0-.166-.339c-.03-.409-.081-.817-.157-1.22-.02-.103-.116-.18-.218-.201C4.935.92 4.931.91 4.924.902 4.846.818 4.738.79 4.631.766L4.624.7C4.468.562 4.33.607 4.206.665L4.192.66c-.14-.034-.282-.068-.422-.1C3.74.516 3.708.472 3.675.43c-.105.008-.201.032-.3.02C3.359.449 3.345.449 3.33.45c-.136-.143-.408-.144-.46.106-.202.96-.182 1.946-.277 2.917-.057.306-.124.604-.177.905-.054.31-.124.608-.176.912-.165.957-.159 1.952-.452 2.82a.426.426 0 0 0-.03.187c.064.427-.051.812-.11 1.195a16.012 16.012 0 0 0-.172 2.03c-.012.49-.043.986-.123 1.466-.084.513.002 1.034-.05 1.553-.002.022.001.046-.004.066-.167.629-.133 1.312-.207 1.986-.035.317-.05.635-.002.963.022.151.011.33-.024.48-.108.456-.132.932-.144 1.422-.018.73-.086 2.87-.262 3.611-.03.12-.045.25-.061.345.01.037.021.069.033.1v.166a.25.25 0 0 0-.14.167c.011.053.034.1.09.124.086.038.222.003.311-.014.289-.054.571-.105.864-.136.693-.072 1.389-.118 2.077-.227a.284.284 0 0 0-.005-.096c-.004-.015-.014-.026-.02-.04l.101-.063c0-.269-.014-.47.003-.666.033-.372.044-1.913.011-2.46.058-.475.113-.95.146-1.425.134-.023.27-.036.405-.038.414-.007.824-.03 1.23-.172.191-.067.39-.102.588-.118.242-.02.317.064.41.364.149.485.208.995.22 1.556.008.442.302 2.31.505 2.56.071.033.143.066.215.103.016.007.029.019.043.027a.138.138 0 0 1 .093-.06c.51-.082 1.021-.167 1.536-.211.02.003.04.007.06.008.047.004.096-.005.142-.014a.491.491 0 0 0 .319-.23c.016-.028.027-.06.039-.09a.476.476 0 0 0 .013-.27zm-3.912-7.04a1.24 1.24 0 0 1-.158.152.918.918 0 0 1-.485.2 1.331 1.331 0 0 1-.331-.01c-.11-.013-.22-.033-.33-.052-.24-.04-.476-.131-.75-.21l-.002-.449c0-.224.002-.45.013-.675.013-.225.033-.45.067-.671.111-.716.247-1.414.25-2.144a.82.82 0 0 1 .03-.242c.17-.521.129-1.091.17-1.646.027-.348.07-.695.109-1.044.003-.027.048-.041.102-.085.063.213.125.419.173.627.015.069.03.139.041.21.061.37.105.741.164 1.108.022.14.062.28.099.416.038.138.09.271.12.41.215 1.021.431 2.03.637 3.053.067.339.133.685.08 1.051z"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    width: 1,
    height: 1,
    viewBox: "0.21 0 0.581 1",
    fill: "#fff",
    x: 226,
    y: 28,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("svg", _extends({
    width: 1,
    height: 1,
    viewBox: "0.768 0.134 0.03 0.051",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    paintOrder: "stroke fill markers",
    fillRule: "evenodd",
    d: "M.786.134l.012.05-.03-.01.018-.04z"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 22,
    viewBox: "0.51 0 10.979 22",
    fill: "#fff",
    x: 231,
    y: 23,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 22,
    viewBox: "0.609 0.669 10.466 20.971",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    paintOrder: "stroke fill markers",
    fillRule: "evenodd",
    d: "M11.018 19.67h.016c.07-.344.033-.66.01-.967-.026-.332-.06-.652-.088-.968-.056-.61-.11-1.196-.164-1.761-.037-.401-.085-.793-.103-1.178-.027-.563-.041-1.107-.154-1.64a1.017 1.017 0 0 1-.02-.25c.025-.772-.084-1.523-.174-2.287-.035-.295-.006-.595-.001-.896.002-.132.023-.263.02-.396-.006-.27-.025-.544-.033-.82-.02-.623.001-1.262-.065-1.93a12.81 12.81 0 0 1-.086-1.547c.004-.137-.013-.283.004-.417.082-.649-.127-1.327-.199-2.042-.016-.162-.122-.323-.177-.461l-.32.004a.64.64 0 0 0-.06-.128l-.04-.055a70.765 70.765 0 0 0-.748-.169 3.162 3.162 0 0 0-.155-.03c-.007.003-.014.003-.02.004l-.007-.008c-.29-.048-.584-.067-.87-.123a.41.41 0 0 0-.068.114.782.782 0 0 0-.047.214c-.02.013-.04.025-.058.042a.341.341 0 0 0-.038-.115l-.047-.027a.876.876 0 0 1-.166.334c.009.038.011.08.011.124a1.15 1.15 0 0 0-.083.238 1.37 1.37 0 0 0-.069.678c-.112.637-.18 1.266-.195 1.892-.005.18-.025.355-.037.53-.06.796-.223 1.525-.265 2.275-.024.435-.116.85-.185 1.267-.016.094-.022.222-.17.2-.026-.054-.062-.115-.084-.182a77.301 77.301 0 0 1-.52-1.641c-.193-.636-.353-1.31-.646-1.944-.218-.471-.364-.99-.537-1.514-.212-.643-.366-1.346-.674-1.989a.421.421 0 0 1-.02-.329 1.245 1.245 0 0 1-.198-.356c-.043.041-.087.089-.135.132-.151-.352-.352-.457-.6-.436-.09.01-.185-.047-.282-.1-.482-.05-.963-.111-1.427-.25C.9.595.592.652.61.943c.25 4.174.563 8.35.653 12.532a.276.276 0 0 0 .103.221c.053.552.122 1.104.176 1.655.078.811.115 1.624.124 2.44.006.587.002 1.175.003 1.763.007.034.013.07.022.104 0 .273.002.761.044 1.015.018.113.048.211.086.297v.038c.007.054.011.11.017.165a.259.259 0 0 0-.075.26c.037.131.201.25.34.193l.018-.006a.267.267 0 0 0 .07.01c.12-.003.247-.04.365-.06.119-.022.238-.044.356-.069.197-.04.394-.086.59-.132.04 0 .077-.003.116-.002.254.008.566.022.793-.116.204-.122.238-.361.217-.588a.278.278 0 0 0 .019-.102c-.005-.259-.007-.724-.012-.983 0-.025-.008-.045-.013-.068.03-.211.023-.43-.033-.65-.14-.55-.162-1.106-.194-1.649a9.265 9.265 0 0 0-.081-.795c-.104-.694-.228-1.362-.296-2.027.045-.432.096-.86.108-1.292.057.101.104.211.15.323.192.474.378.955.576 1.434.105.255.23.497.325.702.207.12.372.075.538.051.33-.045.661-.097.994-.124.18-.015.318-.115.447-.25.15-.155.029-.805.176-.96l.465-1.525c-.008-.192.22-.36.24-.547a.689.689 0 0 1 .071-.25 5.168 5.168 0 0 0-.01.475c-.051.917-.019 1.863-.003 2.852.021 1.337.071 2.766.21 4.354.01.105.037.19.073.262 0 .053-.003.105-.001.158.002.06.006.118.01.178.006.074.008.155.024.227.005.019.013.036.02.055l-.004.043c-.015.101-.004.194.071.27.065.064.18.105.27.07.443-.171.91-.299 1.382-.355.116-.014.233-.024.35-.03.128-.008.266.001.38-.07.226-.144.217-.456.134-.689a.7.7 0 0 0 .004-.082z"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 19,
    viewBox: "0.236 0 10.528 19",
    fill: "#fff",
    x: 243,
    y: 25,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 19,
    viewBox: "0.349 0.554 9.881 17.832",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    paintOrder: "stroke fill markers",
    fillRule: "evenodd",
    d: "M9.775 15.374a32.627 32.627 0 0 0-.92-3.545c-.39-1.233-.809-2.456-1.213-3.683A73.38 73.38 0 0 1 6.52 4.458c-.268-.988-.527-1.982-.869-2.946-.18-.095-.363-.174-.55-.254-.314-.134-.627-.27-.94-.406C3.907.741 3.644.618 3.398.65a.261.261 0 0 0-.121.004c-.013.002-.025.003-.037.006a2.135 2.135 0 0 1-.414.012l-.02.002a.27.27 0 0 0-.186-.12c-.023.115-.05.227-.081.34a.187.187 0 0 1-.134.132c-.123 1.003-.43 1.991-.573 2.986-.032.224-.06.447-.087.67-.004.09-.007.18-.012.267a8.6 8.6 0 0 1-.14 1.124c-.003.02-.01.036-.014.054-.06.56-.119 1.122-.187 1.682-.15 1.236-.326 2.469-.472 3.705a49.264 49.264 0 0 0-.297 3.663 40.287 40.287 0 0 1-.091 1.583c-.002.048-.001.094-.004.143-.01.218-.021.36-.01.47l-.024.08-.07.235c-.023.072-.05.144-.064.217-.027.139-.006.283.1.381a.405.405 0 0 0 .331.097c.15-.014.294-.057.426-.13l.006.002a.769.769 0 0 0 .412-.024l.441-.023c.327-.018.79.023.91-.369v-.017l.001-.003.002-.002.002-.004c.011-.021.026-.05.031-.076.003-.013.004-.03.006-.041.001-.01.005-.028.005-.042v-.006-.004l-.01-.068a.688.688 0 0 0 .109-.5c-.155-1.046 0-1.973.171-2.855l.018-.089c.011-.014.023-.028.034-.044.523-.148 1.045-.3 1.605-.217.383-.096.792.037 1.175-.097.058-.02.163-.02.195.014.11.12.244.116.383.12.166.003.253.099.293.243.159.57.344 1.157.408 1.808.015.149.056.295.072.447.02.192.079.361.16.515.034.256.096.505.197.744l.02.043c.757-.177 1.551-.174 2.31-.345l.057-.019a23.62 23.62 0 0 1-.455-1.97zm-4.232-4.387c-.002.04-.038.076-.072.14-.434-.012-.874-.022-1.314-.035a7.296 7.296 0 0 1-.46-.029c-.12-.01-.189-.085-.189-.185 0-.12.02-.237.043-.352.063-.318.243-.605.188-.943-.005-.026.01-.056.025-.081l.01-.022c.272-.5.302-1.043.333-1.597l.015-.242c.02-.322.08-.643.127-.971.021-.157.055-.31.104-.578.078.284.12.448.174.61.05.152.114.3.173.446v.003c.006.014.013.028.012.042-.025.382.147.745.242 1.108l.01.034c.014.058.012.12.04.173.25.446.244.908.347 1.362.06.27.128.54.182.813a.82.82 0 0 1 .014.147c0 .053-.001.105-.004.157zm1.437-4.29c-.006.026-.075.054-.109.046s-.09-.066-.087-.092c.014-.109.045-.215.071-.322.13.112.155.24.125.368z"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 28,
    viewBox: "0.389 0 11.223 28",
    x: 193,
    y: 20,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 28,
    viewBox: "0.321 0.268 11.1 27.693",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    paintOrder: "stroke fill markers",
    fillRule: "evenodd",
    d: "M11.42 20.12a.394.394 0 0 0-.155-.083c-.257-.068-.534-.186-.777-.137-.323.064-.618-.04-.926-.076-.59-.07-1.177-.313-1.777-.116-.118.039-.267-.032-.404-.063-.014.015-.03.027-.042.043-.029.039-.056.079-.083.12.061.327.081.666.082.994.002.365-.02.75-.127 1.105-.008.35-.119.67-.273.961-.109.206-.225.32-.355.356a.402.402 0 0 1-.193.133c-.272.084-.56-.12-.735-.31a1.213 1.213 0 0 1-.296-.516c-.2-.159-.28-.386-.279-.685 0-.443-.006-.884-.024-1.322-.034-.791-.086-1.575-.115-2.351-.054-1.425-.088-2.831-.266-4.222a4.785 4.785 0 0 1-.021-.711c.02-.9.014-1.797-.14-2.69-.15-.86-.146-1.728-.024-2.634.096-.712.52-1.178.862-1.713.213-.33.57-.232.702.123.567.513.618 1.46.63 2.167.004.186-.001.371-.009.556.002.024.003.05.006.074.033.379.05.76.066 1.142.13.038.254.095.353.192.006.006.009.015.014.022l.056.004a33.89 33.89 0 0 0 3.156.168c.09 0 .14-.05.152-.109.062-.007.117-.05.115-.13l-.009-.3.189-.737-.009-.267c-.182-.413-.178-.874-.104-1.395.09-.633.102-1.322-.09-1.93-.29-.926-.469-1.903-.8-2.829a4.744 4.744 0 0 0-.222-.514c-.01-.007-.02-.01-.03-.02-.415-.43-.83-.868-1.3-1.238A5.605 5.605 0 0 0 6.89.427c-.074.001-.145 0-.214-.006a9.996 9.996 0 0 1-.92-.126C5.198.19 4.667.41 4.136.644c-.091.04-.219.086-.257.172-.135.301-.376.355-.59.481-.088.053-.193.106-.25.195-.273.428-.596.834-.78 1.296-.158.401-.348.745-.583 1.079-.247.352-.87 2.172-.92 2.604C.674 7.214.542 7.94.52 8.667.503 9.234.47 9.8.393 10.357A6.381 6.381 0 0 0 .38 12.18c.159 1.057.124 2.115.076 3.179-.018.4-.091.798.063 1.205.058.151-.002.348-.012.525-.04.71-.168 1.418.032 2.15.034.126.044.262.04.39-.019.438-.07.876.212 1.288.04.059.027.155.043.235.071.368.113.748.223 1.112.365 1.208.812 2.395 1.686 3.428.807.953 1.701 1.654 2.75 2.066.294.115.57.263.826 0 .024-.025.12-.005.128.016.122.367.264.085.396.07.254-.03.508-.077.763-.094a.154.154 0 0 1 .147-.074c.38.02.727-.095 1.04-.283l.265-.18a3.759 3.759 0 0 0 .6-.596.165.165 0 0 1 .025-.083c.115-.185.26-.347.397-.515.44-.725.719-1.553.908-2.376.156-.674.268-1.363.337-2.051a8.178 8.178 0 0 1 .095-1.471zm-4.503-9.923c-.026-.027-.015-.133-.006-.206.041.08.09.148.145.204-.032 0-.14 0-.14.002zm2.23.145a36.926 36.926 0 0 1-.334-.014c.113-.006.224-.002.334.014zM8.052 2.108c-.013.008-.026.013-.04.025l.059.181-.06-.181c.015-.012.028-.017.041-.025z"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 27,
    viewBox: "0.198 0 12.605 27",
    x: 179,
    y: 20,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 27,
    viewBox: "0.393 0.398 12.373 26.503",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    paintOrder: "stroke fill markers",
    fillRule: "evenodd",
    d: "M12.707 26.078c.008-.744-.313-2.105-.165-2.823.024-.113-.028-.257-.033-.385-.007-.18-.033-.371.003-.532.15-.663.067-1.347.05-2.011-.03-1.166-.114-2.307-.099-3.43.011-.853-.133-1.704.026-2.55.038-.2-.006-.424-.019-.636-.026-.448-.06-.895-.082-1.342-.052-.967-.1-1.936-.149-2.915-.007-.166-.025-.339 0-.502.072-.487.05-.966.011-1.454-.04-.506-.128-1.008-.06-1.545.022-.17.01-.36-.031-.52-.123-.483-.103-.986-.07-1.51.027-.408.027-.82.023-1.237.048-.13.034-.32.04-.424.019-.31.016-.622-.008-.931-.006-.095-.019-.19-.03-.284a.776.776 0 0 0 .035-.433.137.137 0 0 0-.069-.139C12.065.458 12.05.44 12.03.43a.255.255 0 0 0-.176-.027.374.374 0 0 0-.166.081c-.124 0-.253.023-.348.043-.27.054-.528.157-.797.218-.279.064-.563.1-.847.139-.534.072-1.063.155-1.55.4a.116.116 0 0 0-.065.136c-.035.034-.057.083-.04.133.013.036.02.073.027.11a.663.663 0 0 1 0 .142.707.707 0 0 1-.03.12v.013l-.023.005c-.062.656-.136 1.263.002 1.841.044.182.025.394.036.59.009.143.017.286.03.428.015.188.046.374.05.562.007.337-.023.678-.001 1.006.048.728.014 1.447-.029 2.156-.033.553-.044 1.095.11 1.616.046.16.042.353.02.526-.093.765-.08 1.506.08 2.242-.172-.054-.233-.213-.293-.378-.226-.636-.453-1.266-.683-1.893-.15-.404-.33-.79-.383-1.241-.018-.149-.1-.284-.15-.427-.25-.714-.513-1.424-.748-2.158a20.362 20.362 0 0 0-.837-2.234c-.239-.523-.479-1.05-.716-1.59a1.42 1.42 0 0 0-.347-.497c-.054-.129-.107-.259-.166-.385-.051-.11-.12-.196-.247-.213-.141-.019-.304.025-.445.046-.182.026-.363.057-.543.09-.698.127-1.393.28-2.104.318a.135.135 0 0 0-.13.117c-.032.031-.069.072-.124.123l-.003.004.072.037c-.031.021-.051.057-.05.107.016.333.03.666.045 1l.005.041C.533 4.383.58 4.991.6 5.604c.03.87.004 1.74.032 2.61.023.727.083 1.46-.039 2.18.003.068.01.135.012.201a.126.126 0 0 0-.043.1v.482a7.904 7.904 0 0 0 0 .907v12.594c.017.029.03.06.03.092-.001.022-.005.045-.007.067a3.318 3.318 0 0 1-.057.357c.015.022.027.045.046.061a.461.461 0 0 0 .077.05.51.51 0 0 0 .303.203c.255.06.52.094.781.136.2.135.435.212.753.25.245.03.5.103.734.05.272.06.544.118.816.176.106.022.174-.069.172-.151a.35.35 0 0 0 .146-.035c.036-.018.07-.04.14-.08l.033-.58c-.06-.397-.099-1.811-.086-2.212.001-.011.004-.02.004-.03-.14-.603-.158-1.17-.016-1.743.09-.36.072-.765.085-1.145.011-.315-.049-.642.001-.939.035-.21.05-.419.056-.626-.033-.582-.086-1.161-.096-1.744-.014-.785.01-1.569-.031-2.352a.159.159 0 0 1 .054-.136c-.009-.053-.014-.106-.024-.158a.202.202 0 0 1 0-.062 1.478 1.478 0 0 1-.075-.205c-.028-.108.029-.209.137-.252.108-.041.203-.003.264.094.031.05.066.12.056.174a1.04 1.04 0 0 0-.019.192c.021.108.038.217.055.325.045.127.116.247.21.363.05.061.07.155.087.238.093.46.151.933.445 1.334.034.047.033.124.044.188.16.883.467 1.744.74 2.644.194.636.394 1.285.594 1.95.104.345.21.693.32 1.044.074.235.196.467.226.706.087.695.297 2.006.484 2.713.142.536.405.82.82.898.328.061.66.096.981.21.392.141.774.17 1.159.154.302-.012.605-.013.904-.043.322-.032.636-.105.857-.493-.017-.077-.06-.184-.059-.283zM3.615 2.236c-.06-.016-.119-.03-.18-.044a.602.602 0 0 1 .19-.017.118.118 0 0 0-.01.06zm4.696 10.886l-.005-.01c-.012-.016-.028-.031-.041-.047.003-.047.03-.094.05-.141l-.004.198zm1.713-11.67l-.288.028a.143.143 0 0 0 .014-.039c.097-.012.192-.035.284-.066a.144.144 0 0 0-.01.077zm.767-.171h-.013c.004-.002.01-.004.013-.007v.007zm1.094.687l-.003-.003c.001-.004.003-.007.003-.011v.014z"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 23,
    viewBox: "0.319 0 9.361 23",
    x: 168,
    y: 22,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 23,
    viewBox: "0.763 0.588 9.101 22.361",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    paintOrder: "stroke fill markers",
    fillRule: "evenodd",
    d: "M9.864 6.014c-.006-.17-.01-.342-.017-.512a2.444 2.444 0 0 1-.013-.397 83.25 83.25 0 0 1-.028-1.583.185.185 0 0 0-.01-.025 10.697 10.697 0 0 0-.038-.963l-.017-.146a1.979 1.979 0 0 0-.036-.291c-.035-.265-.07-.53-.074-.797a.164.164 0 0 1 .002-.162l.001-.073a.127.127 0 0 0-.012-.062l.004-.162c0-.061-.039-.107-.09-.127C9.533.63 9.436.572 9.361.593c-.185.052-.37.11-.553.17a.817.817 0 0 0-.516.04c-.139.052-.285.062-.427.091-.39.08-.778.15-1.165.24l-.012.026-.005.012a.405.405 0 0 1-.032.04c-.004.005-.01.009-.016.013-.014.763.01 1.526-.01 2.288-.015.64-.042 1.28-.068 1.92-.006.163-.015.326-.022.49.038.237.009.482-.003.722.001.066 0 .133-.002.2.002.058.008.115.016.172v.002c-.012.228-.004.457.015.684-.08.417-.175.825-.138 1.236a.631.631 0 0 1-.119.376c-.089.133-.2.247-.32.348-.166.095-.35.108-.539.082-.344-.05-.676-.222-.864-.52a1.367 1.367 0 0 1-.003-.05.148.148 0 0 0-.056-.108 2.222 2.222 0 0 0-.103-.554c-.234-.687-.279-1.425-.276-2.187.003-.87-.183-1.744-.1-2.725.015-.173-.044-.343-.052-.521a1.623 1.623 0 0 0-.034-.263c-.005-.136-.01-.27-.013-.405l-.01-.335c-.003-.084.01-.196-.022-.276-.035-.086-.117-.114-.211-.119-.242.03-.483.062-.723.094a1.073 1.073 0 0 0-.043.006l-.046.006-.008.001-.602.085-.068.04c-.015-.008-.03-.015-.044-.024-.235.035-.47.072-.706.111l-.038.045-.026-.034c-.108.017-.215.034-.323.054a4.78 4.78 0 0 1-.039.087c-.027.007-.056.012-.081.025a.277.277 0 0 0-.146.164c-.024.072.018.185-.017.247a.126.126 0 0 0 .002.134.54.54 0 0 0-.03.188c.04.746.027 1.467.135 2.122.11.673.083 1.322.053 1.954-.013.26-.026.517-.003.765.056.586.155 1.15.187 1.715.017.3.064.57.257.818.083.108.087.27.19.359.333.287.638.596.913.934.184.228.405.422.762.497.351.074.504.337.453.623-.062.347-.005.685.032 1.028.04.35.025.7-.05 1.044-.055.244-.028.484-.018.732.01.246.001.496.003.749.002.175-.018.355.018.53.065.317.071.636.08.964.023.951.038 2.465-.096 3.511.021.051.036.107.055.159-.02.285 0 .571.06.85-.059.063-.043.178.038.219.022.028.054.05.097.055a3140.836 3140.836 0 0 0 2.92.359c.169.02.355.067.524.046a.373.373 0 0 0 .159-.06c.08.051.215.016.215-.109v-.361a.149.149 0 0 0 .007-.187 90.183 90.183 0 0 0-.139-6.44c.01-.015.016-.03.025-.043a2.212 2.212 0 0 0-.036-.12c-.023-.398-.053-.793-.081-1.19-.006-.363-.005-.722.013-1.078.003-.062.014-.12.024-.178-.005-.224-.023-.45.021-.67.01-.044.026-.085.042-.126-.002-.02-.004-.037.002-.057a.325.325 0 0 1 .07-.121l.01-.008a.597.597 0 0 1 .032-.025c.07-.094.157-.176.253-.248.244-.183.486-.355.702-.572.118-.119.227-.245.331-.375.066-.17.116-.344.15-.524.083-.43.2-.852.326-1.278.202-.689.366-1.397.344-2.133-.01-.34-.106-.673.02-1.027zM7.395 17.64c.01-.039.017-.08.023-.12.002.046.005.092.006.139-.008-.008-.018-.013-.029-.019z"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 19,
    viewBox: "0.514 0 9.972 19",
    x: 158,
    y: 25,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 19,
    viewBox: "1 0.229 9.348 17.811",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    paintOrder: "stroke fill markers",
    fillRule: "evenodd",
    d: "M10.347 12.644c-.008-.385-.035-.763-.034-1.131.002-.285-.016-.555-.11-.828a2.124 2.124 0 0 1-.111-.906c.042-.435.017-.874-.267-1.257a1.4 1.4 0 0 1-.182-.309c-.133-.34-.482-.529-.838-.654-.378-.133-.815-.18-1.236-.224-.319-.032-.655.003-.98-.009-.383-.015-.77-.03-1.144-.078-.945-.123-1.4-.665-1.259-1.284.028-.123.015-.25.013-.376a6.372 6.372 0 0 1 .198-1.738c.043-.172.1-.352.193-.518.137-.244.435-.326.634-.215.543.183.736.822.793 1.335.02.178.024.38.006.583.029.24.04.482.042.722.14.162.258.339.342.523.15.325.497.36.866.38.14.008.295-.042.425-.018.55.1 1.089-.036 1.648-.103.038-.1.092-.181.094-.26.012-.387 0-.777.012-1.177s-.225-.766-.115-1.203c.008-.033-.021-.068-.03-.102L8.946 2.29c-.027-.111-.043-.233-.104-.324-.393-.59-.881-1.123-1.54-1.45C6.92.329 6.496.479 6.121.26 6.106.251 6.089.246 6.073.24c-.08-.005-.16-.012-.24-.01a2.765 2.765 0 0 0-.198.01L5.56.25l-.045.007c-.536.102-.936-.003-1.389.242a.567.567 0 0 1-.12.044c-.276.146-.56.27-.83.425a2.819 2.819 0 0 0-.559.406 2.96 2.96 0 0 0-.844 1.553c-.04.2-.108.381-.186.568-.252.599-.53 1.165-.362 1.728.024.081-.006.187-.05.271-.148.29-.15.568-.127.846.01.116.033.236 0 .348-.09.293-.04.563.034.83.05.053.09.117.112.187.012.038.022.094.045.127l-.022-.052.028.061c.04.088.079.177.115.267.032.078.057.16.073.244.185.132.271.302.336.488a.423.423 0 0 0 .197.202c.22.12.44.253.693.33.347.106.725.162 1.005.371.038.029.11.037.168.046.376.06.754.114 1.132.178.534.09 1.091.116 1.6.316.242.096.383.221.41.444.045.375.127.756.176 1.149a.6.6 0 0 1-.042.283c-.057.24-.097.484-.166.721-.073.244-.171.5-.354.685a.703.703 0 0 1-.735.17c-.315-.115-.51-.404-.638-.719a1.031 1.031 0 0 1-.225-.425c-.111-.425-.23-.831-.294-1.235-.073-.462-.481-.726-1.054-.677-.562.049-1.116.14-1.669.22-.27.039-.41.176-.432.386-.005.046-.006.094-.013.14-.081.552.153 1.11.22 1.715.02.183.143.365.1.57a.327.327 0 0 0 .036.211c.202.365.353.767.667 1.115.203.225.348.507.506.783.023.04.015.098.008.158.037.025.075.046.111.073.21.147.34.33.408.525l.05-.018c.228.157.455.288.652.462.213.188.4.417.63.67.115.038.28.077.438.147.637.284 1.265.202 1.894.168a.888.888 0 0 0 .393-.148c.178-.11.353-.224.526-.34a3.088 3.088 0 0 1 .681-.56l.168-.23.012-.063c-.002-.02-.014-.05-.004-.06.27-.35.633-.626.683-1.112.385-.322.422-.751.407-1.23-.015-.444.128-.869.2-1.288.02-.109.036-.218.033-.328z"
  })))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogoDayMobile, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logo-day-mobile.38a27f27.svg";
export { ForwardRef as ReactComponent };